/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { UsersStrictHttpResponse } from '../../users-strict-http-response';
import { UsersRequestBuilder } from '../../users-request-builder';


export interface UsersControllerSoftDelete$Params {

/**
 * The tenant identifier.
 */
  tenant: string;

/**
 * The ID of the user to soft delete.
 */
  id: string;
}

export function usersControllerSoftDelete(http: HttpClient, rootUrl: string, params: UsersControllerSoftDelete$Params, context?: HttpContext): Observable<UsersStrictHttpResponse<void>> {
  const rb = new UsersRequestBuilder(rootUrl, usersControllerSoftDelete.PATH, 'patch');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as UsersStrictHttpResponse<void>;
    })
  );
}

usersControllerSoftDelete.PATH = '/o2-users/users/{tenant}/{id}/soft-delete';
